import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";

const Reason = ({ data }) => {
    const [open, setOpen] = useState(false);

    // Correct mapping of return vs replacement
    const image1 =
        data?.order_item_status === "Returned"
            ? data?.return_image1
            : data?.replacement_image1;
    const image2 =
        data?.order_item_status === "Returned"
            ? data?.return_image2
            : data?.replacement_image2;
    const image3 =
        data?.order_item_status === "Returned"
            ? data?.return_image3
            : data?.replacement_image3;
    const image4 =
        data?.order_item_status === "Returned"
            ? data?.return_image4
            : data?.replacement_image4;

    const videoUrl =
        data?.order_item_status === "Returned"
            ? data?.return_video
            : data?.replacement_video;


    const images = [image1, image2, image3, image4].filter(Boolean);

    const reasonText =
        data?.order_item_status === "Returned"
            ? data?.reason_for_return_choice?.choice
            : data?.reason_for_replacement_choice?.choice;

    return (
        <>
            <Button onClick={() => setOpen(true)} variant="outlined">
                View
            </Button>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {data?.order_item_status} Reason
                    <IconButton
                        aria-label="close"
                        onClick={() => setOpen(false)}
                        sx={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    {reasonText && (
                        <Typography
                            variant="subtitle1"
                            sx={{ mb: 2, fontWeight: 1000, color: "text.primary" }}
                        >
                            {reasonText}
                        </Typography>
                    )}

                    <Grid container spacing={2}>
                        {/* Show only available images */}
                        {images.map((img, index) => (
                            <Grid item xs={6} sm={3} key={index}>
                                <a href={img} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={img}
                                        alt={`reason-${index + 1}`}
                                        style={{
                                            width: "100%",
                                            height: "150px",
                                            objectFit: "cover",
                                            borderRadius: "10px",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                            cursor: "pointer",
                                        }}
                                    />
                                </a>
                                <p className="p-3">{`Reason-${index + 1}`}</p>
                            </Grid>
                        ))}

                        {/* Show video only if available */}
                        {videoUrl && (
                            <Grid item xs={12}>
                                <video
                                    controls
                                    width="100%"
                                    style={{
                                        borderRadius: "10px",
                                        marginTop: "16px",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    }}
                                >
                                    <source src={videoUrl} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default Reason;
